import React from "react";
import "./AboutPage.css";
import {
  AiOutlineBarChart,
  AiOutlineTwitter,
  AiFillLinkedin,
} from "react-icons/ai";
import { BiMedal } from "react-icons/bi";
import { BsFillPeopleFill, BsLightbulb, BsGlobe } from "react-icons/bs";
import { LiaGlobeEuropeSolid } from "react-icons/lia";
import { NavLink } from "react-router-dom";

const team = [
  {
    id: 1,
    image: "/admin.jpeg",
    name: "Muhammad Awais",
    role: "Project Director",
    about:
      "Visionary leader driving multi-disciplinary teams across blockchain and enterprise cloud solutions.",
    linkdin: "https://www.linkedin.com/company/xperts-house-technology/",
    twitter: "https://x.com/couponsspot338",
  },
  {
    id: 2,
    image: "/team1.jpg",
    name: "Mariam Zahra",
    role: "HR & Client Services Director",
    about:
      "Bridging the gap between human talent and digital excellence with a focus on global client relations.",
    linkdin: "https://www.linkedin.com/company/xperts-house-technology/",
    twitter: "https://x.com/couponsspot338",
  },
  {
    id: 3,
    image: "/t-usman.jpeg",
    name: "Usman Ali",
    role: "CEO",
    about:
      "Strategist specialized in scaling IT operations and delivering high-performance software ecosystems.",
    linkdin: "https://www.linkedin.com/company/xperts-house-technology/",
    twitter: "https://x.com/couponsspot338",
    grayscale: true,
  },
  {
    id: 4,
    image: "/team3.jpg",
    name: "Zahra Ali",
    role: "Technical Architect",
    about:
      "Engineer architecting the technical backbone of decentralized and mobile innovation projects.",
    linkdin: "https://www.linkedin.com/company/xperts-house-technology/",
    twitter: "https://x.com/couponsspot338",
  },
  {
    id: 5,
    image: "/t-umar.jpeg",
    name: "Muhammad Umar",
    role: "Team Manager",
    about:
      "Dedicated contributor supporting delivery excellence across projects and operations.",
    linkdin: "",
    twitter: "",
    grayscale: true,
  },
];

const AboutPage = () => {
  return (
    <div className="about-v3">
      {/* --- Section 1: Cinematic Hero (Text Only) --- */}
      <section className="v3-hero-section compact">
        <div className="v3-container">
          <div className="v3-hero-centered-content">
            <div className="v3-badge">Est. 2013</div>
            <h1 className="v3-hero-title-large">
              Architecting{" "}
              <span className="gradient-text">Human Potential</span>
            </h1>
            <p className="v3-hero-p-centered">
              XHT is a global engineering powerhouse dedicated to designing the
              next generation of digital infrastructure. We combine technical
              mastery with visionary strategy to empower brands at scale.
            </p>

            <div className="v3-stats-grid">
              <div className="v3-stat-item">
                <div className="v3-stat-num">200+</div>
                <div className="v3-stat-lbl">Global Deployments</div>
              </div>
              <div className="v3-stat-item">
                <div className="v3-stat-num">50+</div>
                <div className="v3-stat-lbl">Core Engineers</div>
              </div>
              <div className="v3-stat-item">
                <div className="v3-stat-num">98%</div>
                <div className="v3-stat-lbl">Client Retention</div>
              </div>
              <div className="v3-stat-item">
                <div className="v3-stat-num">10+</div>
                <div className="v3-stat-lbl">Years of Mastery</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* --- Section 2: Minimalist Values --- */}
      <section className="v3-values-section">
        <div className="v3-container">
          <div className="v3-section-head center">
            <h2 className="v3-title">
              The principles that <span className="blue-glow">guide us</span>
            </h2>
          </div>

          <div className="v3-values-grid">
            <ValueCard
              icon={<AiOutlineBarChart />}
              title="Integrity"
              desc="Upholding the highest ethical standards in every logic block."
            />
            <ValueCard
              icon={<BiMedal />}
              title="Excellence"
              desc="Continuous iteration toward absolute technical perfection."
            />
            <ValueCard
              icon={<BsLightbulb />}
              title="Innovation"
              desc="Approaching complexity with a neural-first mindset."
            />
            <ValueCard
              icon={<BsFillPeopleFill />}
              title="Synergy"
              desc="Collaborative growth that scales talent and product."
            />
            <ValueCard
              icon={<BsGlobe />}
              title="Global"
              desc="Connecting markets through decentralized ecosystems."
            />
            <ValueCard
              icon={<LiaGlobeEuropeSolid />}
              title="Impact"
              desc="Creating measurable value for human progress."
            />
          </div>
        </div>
      </section>

      {/* --- Section 3: Team Marquee --- */}
      <section className="v3-team-section">
        <div className="v3-container">
          <div className="v3-section-head">
            <div className="v3-badge">Leadership</div>
            <h2 className="v3-title">
              Architects of the <span className="blue-glow">Vision</span>
            </h2>
          </div>
        </div>

        <div className="team-marquee-wrapper">
          <div className="team-marquee-content">
            {/* Double the array for infinite effect */}
            {[...team, ...team].map((member, index) => {
              const hasSocials = Boolean(member.linkdin || member.twitter);

              return (
                <div className="v3-team-card" key={`${member.id}-${index}`}>
                  <div
                    className={`v3-member-image${
                      member.grayscale ? " is-grayscale" : ""
                    }`}
                  >
                    <img src={member.image} alt={member.name} />
                    {hasSocials && (
                      <div className="v3-member-socials">
                        {member.linkdin && (
                          <a href={member.linkdin}>
                            <AiFillLinkedin />
                          </a>
                        )}
                        {member.twitter && (
                          <a href={member.twitter}>
                            <AiOutlineTwitter />
                          </a>
                        )}
                      </div>
                    )}
                  </div>
                <div className="v3-member-details">
                  <h3>{member.name}</h3>
                  <span className="v3-role">{member.role}</span>
                  <p className="v3-bio">{member.about}</p>
                </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* --- Section 4: Modernized CTA --- */}
      <section className="v3-final-cta">
        <div className="v3-container">
          <div className="v3-cta-card">
            <div className="v3-cta-content">
              <div className="v3-badge-alt">Join the future</div>
              <h2 className="v3-cta-title">
                Ready to start your <br />
                <span className="grad-blue">digital revolution?</span>
              </h2>
              <p className="v3-cta-p">
                Our engineering experts are ready to turn your complex
                challenges into seamless, high-performance solutions.
              </p>

              <NavLink to="/contactus" className="v3-main-btn">
                <span>Book a Call</span>
                <div className="btn-icon-box">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M5 12H19M19 12L12 5M19 12L12 19"
                      stroke="currentColor"
                      strokeWidth="3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </NavLink>
            </div>

            <div className="cta-decorative">
              <div className="cta-orb-1"></div>
              <div className="cta-orb-2"></div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

const ValueCard = ({ icon, title, desc }) => (
  <div className="v3-value-card">
    <div className="v3-value-icon">{icon}</div>
    <h3>{title}</h3>
    <p>{desc}</p>
  </div>
);

export default AboutPage;
